import React from 'react';
import dayjs from 'dayjs';
import { useCountDown } from 'ahooks';

interface props {
  endTime: string;
  startText?: string;
  endText?: string;
}

const DateFormat: React.FC<props> = ({ endTime, startText, endText }) => {
  const [countdown, formattedRes] = useCountDown({
    targetDate: dayjs(endTime).format('YYYY-MM-DD HH:mm:ss'),
  });
  const { days, hours, minutes, seconds, milliseconds } = formattedRes;

  return (
    <div className="flex_1" style={{ fontSize: 12, gap: 6 }}>
      {startText ? <span className="col808">{startText}</span> : null}
      <span style={{ color: '#F77234', fontWeight: 'bold', fontSize: 18 }}>{days}</span>
      <span style={{ color: '#5E7288' }}>天</span>
      <span style={{ color: '#F77234', fontWeight: 'bold', fontSize: 18 }}>{hours}</span>
      <span style={{ color: '#5E7288' }}>时</span>
      <span style={{ color: '#F77234', fontWeight: 'bold', fontSize: 18 }}>{minutes}</span>
      <span style={{ color: '#5E7288' }}>分</span>
      <span style={{ color: '#F77234', fontWeight: 'bold', fontSize: 18 }}>{seconds}</span>
      <span style={{ color: '#5E7288' }}>秒</span>
      {endText ? <span className="col808">{endText}</span> : null}
    </div>
  );
};

export default DateFormat;
